// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/workdoc/qrtracker/Tracker.css
// module id = 2050
// module chunks = 0